var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('svg',{attrs:{"id":`svg-${_vm.runid}`,"height":"50","width":"50","viewport":"0 0 50 50","viewBox":`${_vm.svgprops.x} ${_vm.svgprops.y} ${_vm.svgprops.width} ${_vm.svgprops.height}`,"preserveAspectRatio":"xMinYMin meet"}},[_c('g',[_c('path',{attrs:{"vector-effect":"non-scaling-stroke","d":_vm.svgprops.path}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }